import React, { useState, useEffect } from "react";

const DEFAULT_MESSAGES = [
  "Loading your workspace...",
  "Preparing your data...",
  "Almost ready...",
  "Setting up your environment...",
  "Just a moment more...",
  "Preparing starship for you",
];

const Loading = ({
  loading,
  messages = DEFAULT_MESSAGES,
  progressDuration = 3000,
  messageDuration = 1800,
}: {
  loading?: boolean;
  messages?: string[];
  progressDuration?: number;
  messageDuration?: number;
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!loading) {
      setProgress(0);
      setCurrentMessageIndex(0);
      return;
    }

    const intervalMs = 100;
    const totalSteps = Math.ceil(progressDuration / intervalMs);
    const increment = 100 / totalSteps;
    let step = 0;
    setProgress(0);

    const progressInterval = setInterval(() => {
      step++;
      setProgress((prev) => {
        const next = prev + increment;
        return next >= 100 ? 100 : next;
      });
      if (step >= totalSteps) {
        clearInterval(progressInterval);
      }
    }, intervalMs);

    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
    }, messageDuration);

    return () => {
      clearInterval(progressInterval);
      clearInterval(messageInterval);
    };
  }, [loading, messages.length, messageDuration, progressDuration]);

  if (!loading) return null;

  return (
    <div className="bg fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 dark:bg-black">
      <div className="mx-4 w-full max-w-md rounded-lg p-8">
        <div className="mb-8 text-center">
          <div className="flex h-6 items-center justify-center">
            <p
              key={currentMessageIndex}
              className="transform font-medium transition-all duration-500 ease-in-out"
              style={{
                animation: "fadeInUp 0.5s ease-out forwards",
              }}
            >
              {messages[currentMessageIndex]}
            </p>
          </div>
        </div>

        <div className="w-full">
          <div className="h-3 w-full overflow-hidden rounded-full">
            <div
              className="h-full rounded-full bg-primary transition-all duration-200 ease-out"
              style={{
                width: `${progress}%`,
                boxShadow: "0 0 10px rgba(59, 130, 246, 0.5)",
              }}
            >
              <div className="h-full w-full animate-pulse bg-gradient-to-r from-transparent via-white to-transparent opacity-10"></div>
            </div>
          </div>
          <div className="mt-2 text-center">
            <span className="text-sm text-gray-500">
              {Math.round(progress)}%
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;

export const IosLoader = () => (
  <div className="spinner center">
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
  </div>
);
